let widgetInstancePure = null

export default function getSurveyWidgetPure() {
  if (null == widgetInstancePure && 'undefined' !== typeof window.$SurveyWidget) {
    widgetInstancePure = window.$SurveyWidget()
    widgetInstancePure.config('toolbar', {
      type: 'preview',
      props: {
        toolbar: {
          show: false,
          collapsible: false,
          controls: false
        },
        closeable: false
      }
    })

    if ('development' === process.env.NODE_ENV) {
      window.$SurveyWidgetInstance = widgetInstancePure
    }
  }

  return widgetInstancePure
}

window.getSurveyWidgetPure = getSurveyWidgetPure
